import type { Translations } from './types';

export const es: Translations = {
  appName: 'Entrenador Alfabeto OTAN',
  converter: 'Convertidor',
  quiz: 'Quiz de Letras',
  wordQuiz: 'Quiz de Palabras',
  settings: 'Configuración',
  enterText: 'Ingrese texto para convertir',
  placeholder: 'Escriba su mensaje aquí...',
  natoAlphabet: 'Alfabeto OTAN',
  playPronunciation: 'Reproducir Pronunciación',
  stop: 'Parar',
  quickReference: 'Referencia Rápida',
  showLess: 'Mostrar Menos',
  viewFullAlphabet: 'Ver Alfabeto Completo →',
  copied: '¡Copiado!',
  copyFailed: 'Error al copiar',
  speechNotAvailable: 'Síntesis de voz no disponible',
  voiceSettings: 'Configuración de Voz',
  textToSpeechVoice: 'Voz de Síntesis',
  testVoice: 'Probar Voz',
  notifications: 'Notificaciones',
  spacedRepetitionReminders: 'Recordatorios de Repetición Espaciada',
  notificationDescription: 'Reciba notificaciones diarias para practicar',
  language: 'Idioma',
  interfaceLanguage: 'Idioma de la Interfaz',
  about: 'Acerca del Entrenador Alfabeto OTAN',
  question: 'Pregunta',
  questionCount: '{current} de {total}',
  reviewYourAnswers: 'Revise Sus Respuestas',
  typeNatoWordForLetter: 'Escriba la palabra OTAN para la letra {letter}',
  startVoiceInput: 'Iniciar entrada de voz',
  stopVoiceInput: 'Detener entrada de voz',
  aboutDescription:
    'Aprenda el alfabeto fonético OTAN a través de cuestionarios interactivos y repetición espaciada.',
  version: 'Versión 1.0.0',
  builtWith: 'Construido con tecnologías web modernas',
  currentStreak: 'Racha Actual',
  totalSessions: 'Sesiones Totales',
  accuracy: 'Precisión',
  learningProgress: 'Progreso de Aprendizaje',
  startQuiz: 'Iniciar Cuestionario',
  restartQuiz: 'Reiniciar Cuestionario',
  nextQuestion: 'Siguiente Pregunta',
  submitAnswer: 'Enviar Respuesta',
  showStats: 'Mostrar Estadísticas',
  hideStats: 'Ocultar Estadísticas',
  correctAnswer: 'Respuesta Correcta',
  yourAnswer: 'Su Respuesta',
  correct: 'Correcto',
  incorrect: 'Incorrecto',
  sessionComplete: '¡Sesión Completa!',
  score: 'Puntuación',
  tryAgain: 'Intentar Nuevamente',
  hint: 'Pista',
  femaleVoice: 'Voz Femenina',
  maleVoice: 'Voz Masculina',
  robotVoice: 'Voz Robot',
  dailyReminders:
    'Recibirá recordatorios diarios para practicar el alfabeto OTAN basados en su progreso de aprendizaje.',
  speakAnswer: 'Habla tu respuesta',
  voiceInputActive: 'Escuchando...',
  adaptiveLearning: 'Aprendizaje Adaptativo',
  spacedRepetitionDescription:
    'Cada conjunto de 10 preguntas se adapta según tu rendimiento usando repetición espaciada.',
  skipQuestion: 'Saltar',
  pressEnterToSubmit: 'Presiona Enter para enviar',
  pressEscapeToSkip: 'Presiona Escape para saltar',
  exampleAnswers: 'Ejemplo: "Alpha", "Bravo", "Charlie"',
  notificationsPanelTitle: 'Notificaciones',
  markAllAsRead: 'Marcar todo como leído',
  noNotifications: 'Sin notificaciones',
  natoHints: {
    A: 'Primera letra del alfabeto griego',
    B: '¡Bien hecho, aplausos!',
    C: 'C fonética, como el nombre',
    D: 'Formación triangular de río',
    E: 'Reflejo del sonido',
    F: 'Baile de salón',
    G: 'Deporte con palos y hoyos',
    H: 'Lugar para pasar la noche',
    I: 'Gran país asiático',
    J: 'Heroína de Shakespeare',
    K: 'Unidad de peso (1000 gramos)',
    L: 'Capital de Perú',
    M: 'Abreviatura de micrófono',
    N: 'Mes de otoño',
    O: 'Premio de la Academia',
    P: 'Padre, informal',
    Q: 'Provincia canadiense',
    R: 'Personaje de Shakespeare',
    S: 'Cadena montañosa',
    T: 'Baile argentino',
    U: 'Misma ropa para todos',
    V: 'Ganador, campeón',
    W: 'Bebida alcohólica fuerte',
    X: 'Imagen médica',
    Y: 'Jugador de béisbol americano',
    Z: 'Nación guerrera africana',
  },
  // Quiz specific
  learning: 'Aprendiendo',
  review: 'Repaso',
  mastered: 'Dominado',
  lastFiveTimes: 'Últimos 5 Tiempos',
  quizTimes: 'Tiempos de Cuestionarios',
  bestTime: 'Mejor Tiempo',
  noTimesRecorded: 'No Hay Tiempos Registrados',
  // Settings
  theme: 'Tema',
  lightTheme: 'Claro',
  darkTheme: 'Oscuro',
  rainbowTheme: 'Arcoíris',
  systemTheme: 'Sistema',
  appearance: 'Apariencia',
  chooseTheme: 'Elige tu tema preferido',
  speechRate: 'Velocidad de la voz',
  pitch: 'Tono',
  volume: 'Volumen',
  // Custom Word Input
  enterCustomWord: 'Ingresar palabra personalizada',
  enterYourWordOrPhrase: 'Ingrese su palabra o frase...',
  useThisWord: 'Usar esta palabra',
  // WordDisplay localization
  currentWordLabel: 'Palabra Actual',
  customWordLabel: 'Personalizado',
  currentWordSpeech: 'La palabra actual es: {word}',
  difficultyLabels: {
    easy: 'Fácil',
    medium: 'Medio',
    hard: 'Difícil',
  },
  categoryLabels: {
    animals: 'Animales',
    places: 'Lugares',
    nature: 'Naturaleza',
    technology: 'Tecnología',
    home: 'Hogar',
    objects: 'Objetos',
    transport: 'Transporte',
  },
  // NATO Input specific translations
  natoInputTitle: 'Tu entrada del alfabeto OTAN',
  natoInputPlaceholder: 'Introduce palabras OTAN: "Alpha Bravo Charlie..."',
  natoInputListening: 'Escuchando...',
  natoInputLiveScore: 'Puntuación en vivo',

  // Quiz Header translations
  wordQuizInstructions:
    'Convierte la palabra de abajo al alfabeto OTAN. Di cada palabra OTAN separada por espacios o comas.',

  // Quiz Actions translations
  retry: 'Reintentar',
  checkAnswer: 'Verificar respuesta',
  newRandomWord: 'Nueva palabra aleatoria',
  cancelCustom: 'Cancelar personalizado',
  customWord: 'Palabra personalizada',

  // Quiz Results translations
  perfect: '¡Perfecto!',
  results: 'Resultados',
  expectedNato: 'OTAN esperado:',
  play: 'Reproducir',
  letterByLetter: 'Letra por letra:',
};
